module.exports = __webpack_public_path__ + "images/柏纳长图_04-2.jpg?v=2e978c1e";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/zhongduan1/柏纳长图_04-2.jpg
 ** module id = 140
 ** module chunks = 1 2
 **/